import LegalPage from './LegalPage';
import { COMPANY, PRODUCTION_DOMAIN, SUPPLEMENT_DISCLAIMER } from './legalConstants';

export default function AlgemeneVoorwaarden() {
  return (
    <LegalPage title="Algemene voorwaarden" testId="legal-page-terms">
      <p>
        Deze algemene voorwaarden zijn van toepassing op iedere bestelling
        die via <strong>{PRODUCTION_DOMAIN}</strong> wordt geplaatst bij
        {' '}<strong>{COMPANY.legalName}</strong> ("verkoper", "wij").
      </p>

      <h2>1. Identiteit van de verkoper</h2>
      <ul>
        <li>{COMPANY.legalName}</li>
        <li>
          Adres: {COMPANY.address.street}, {COMPANY.address.postalCode}
          {' '}{COMPANY.address.city}, {COMPANY.address.country}
        </li>
        <li>Ondernemingsnummer / BTW: {COMPANY.vatNumber}</li>
        <li>{COMPANY.rpr}</li>
        <li>E-mail: {COMPANY.email}</li>
        <li>Niet telefonisch bereikbaar.</li>
      </ul>

      <h2>2. Toepasselijkheid</h2>
      <p>
        Door een bestelling te plaatsen erkent de klant kennis te hebben
        genomen van deze voorwaarden en aanvaardt hij/zij deze
        uitdrukkelijk. Afwijkingen zijn slechts geldig indien schriftelijk
        bevestigd door de verkoper.
      </p>

      <h2>3. Aanbod en prijzen</h2>
      <p>
        Alle prijzen worden vermeld in euro, inclusief Belgische BTW,
        exclusief leveringskosten tenzij anders aangegeven. De verkoper
        behoudt zich het recht voor prijzen aan te passen; voor reeds
        geplaatste bestellingen geldt de prijs die op het ogenblik van
        de bestelling werd weergegeven.
      </p>

      <h2>4. Totstandkoming van de overeenkomst</h2>
      <p>
        De overeenkomst komt tot stand wanneer de klant zijn bestelling
        bevestigt en de betaling succesvol door onze betalingsprovider
        is afgehandeld. De klant ontvangt nadien een bevestigingsmail.
      </p>

      <h2>5. Betaling</h2>
      <p>
        Betaling gebeurt online via de betalingsprovider Mollie. Zolang
        de betaling niet is voltooid, wordt de bestelling niet verwerkt.
      </p>

      <h2>6. Levering</h2>
      <p>
        Zie het hoofdstuk{' '}
        <a href="/verzending" data-testid="link-shipping">
          Verzending &amp; levering
        </a>
        . Onze online bestelling is bestemd voor klanten in{' '}
        <strong>België, Nederland, Frankrijk en Luxemburg</strong>.
        Voor leveringen naar andere Europese landen vragen wij u
        vooraf contact op te nemen via{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
        Leveringen buiten de Europese Unie zijn niet beschikbaar
        via de standaard checkout.
      </p>

      <h2>7. Herroepingsrecht (B2C)</h2>
      <p>
        Consumenten beschikken over een herroepingstermijn van 14
        kalenderdagen, te tellen vanaf de dag na ontvangst van de
        goederen. De voorwaarden en uitzonderingen voor verzegelde
        voedingssupplementen staan op{' '}
        <a href="/herroepingsrecht" data-testid="link-withdrawal">
          de herroepingspagina
        </a>
        .
      </p>
      <p>
        Voor B2B-klanten (verkoop tussen ondernemingen) is dit
        wettelijke herroepingsrecht niet van toepassing.
      </p>

      <h2>8. Conformiteit en garantie</h2>
      <p>
        De wettelijke garantie van 2 jaar (Boek IX WER) is van toepassing
        op niet-verbruiksgoederen. Voor voedingssupplementen geldt de
        wettelijke conformiteitsregel binnen de houdbaarheidstermijn
        vermeld op de verpakking.
      </p>

      <h2>9. Voedingssupplementen — disclaimer</h2>
      <p><em>{SUPPLEMENT_DISCLAIMER}</em></p>

      <h2>10. Aansprakelijkheid</h2>
      <p>
        De verkoper is niet aansprakelijk voor schade voortvloeiend uit
        verkeerd gebruik van producten of gebruik in strijd met de
        bijgeleverde informatie. Niets in deze voorwaarden beperkt
        aansprakelijkheid in geval van opzet, zware fout of
        wettelijke dwingende bepalingen.
      </p>

      <h2>11. Geschillen en toepasselijk recht</h2>
      <p>
        Op deze overeenkomst is uitsluitend het Belgisch recht van
        toepassing. Geschillen worden voorgelegd aan de bevoegde
        rechtbanken van het arrondissement van de maatschappelijke
        zetel van de verkoper. De consument kan een geschil ook
        voorleggen aan het Europees ODR-platform:{' '}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        .
      </p>
    </LegalPage>
  );
}
